// extracted by mini-css-extract-plugin
module.exports = {"sidebarContent":"style_sidebarContent__2WZ4w","forTest":"style_forTest__j_m0f"};